var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "12px",
    height: "21px",
    viewBox: "0 0 12 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.0171088,16.941421 C15.1210617,16.941421 17.3598195,14.6427654 19.5466424,12.4543069 C19.6996499,12.3011849 22.1046258,9.87995837 23.0392267,8.98972244 C23.259248,8.78014543 23.513437,8.76565358 23.6272622,8.76030654 C23.811068,8.75167213 23.9857064,8.75611098 24.1674234,8.81886215 C24.4934969,8.93146294 24.7073761,9.14927323 24.7277261,9.17702409 C24.9883844,9.53247758 25.1026346,9.91173479 24.9679376,10.3842614 C24.9371129,10.4923969 24.8553491,10.6633449 24.608555,10.9252236 C24.2590525,11.2960885 23.3817207,12.1308166 22.9083826,12.6265214 C22.9083826,12.6265214 20.277958,15.2570223 15.0171088,20.518024 C8.80950741,14.3060854 5.62619333,11.1270247 5.46716658,10.9808419 C5.15638318,10.6951592 4.80909313,10.1211617 5.12430158,9.52172013 C5.12430158,9.52172013 5.2758595,8.98972244 5.88815658,8.81886215 C6.08528173,8.76385476 6.40895156,8.69626473 6.69683427,8.81886215 C7.07730972,8.980891 7.42023452,9.36991438 7.57204029,9.52172013 C12.5322866,14.4681874 15.0139761,16.941421 15.0171088,16.941421 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDD6A-Food-&-Beverage",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cart",
    transform: "translate(-9.000000, -56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars/navbar\\u2014ondark/regular"
  }, /*#__PURE__*/React.createElement("g", {
    id: "barbuttons-left-Bars/navbar\\u2014ondark/_/left-back",
    transform: "translate(0.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-left-icon/i-back",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(15.012410, 14.634012) rotate(90.000000) translate(-15.012410, -14.634012) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color-color/bright-blue",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.250000, 1.250000)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBack);
export default __webpack_public_path__ + "static/media/i-back.7491a168ee285c5e0cb052074c11fc74.svg";
export { ForwardRef as ReactComponent };